export const validation  = {
  blockTitleMaxChar: 50,
  blockParagraphMaxChar: 400,
  featureParts: {
    min: 2,
    max: 9
  }
}
